import s from "./WidgetCard.module.css";

export const WidgetFiltersDisplay = ({ filters, dateTypeMetadata }) => {
    const formatDateToUTC = (dateString) => {
        const date = new Date(dateString);
        return new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            timeZone: "UTC",
        }).format(date);
    };

    return (
        <div className={s.filterContainer}>
            {filters.map((filter, filterIdx) => {
                const { name, values, minimum, maximum } = filter;
                const isDateFilter = dateTypeMetadata.some(
                    (metadata) => metadata.name === name,
                );

                let filterContent = "";

                if (values && values.length > 0) {
                    filterContent = values.join(", ");
                } else if (minimum !== undefined && maximum !== undefined) {
                    filterContent = `From ${
                        isDateFilter ? formatDateToUTC(minimum) : minimum
                    } to ${
                        isDateFilter ? formatDateToUTC(maximum) : maximum
                    }`;
                }

                return (
                    <div key={filterIdx} className={s.filterItem}>
                        <p className={s.count}>
                            {name}: <span>{filterContent}</span>
                        </p>
                    </div>
                );
            })}
        </div>
    );
};
